import { render } from "./DraggableDataGrid.vue?vue&type=template&id=43db06e2&scoped=true"
import script from "./DraggableDataGrid.vue?vue&type=script&lang=js"
export * from "./DraggableDataGrid.vue?vue&type=script&lang=js"

import "./DraggableDataGrid.vue?vue&type=style&index=0&id=43db06e2&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43db06e2"]])

export default __exports__